import { IMG } from '../../data/santaStages';

export default function GameBanner() {
  return (
    <div className="row">
      <img src={`${IMG}/topbanner.png`} className="img-fluid desk" style={{ width: '100%' }} alt="" />
      <img src={`${IMG}/topbannermob.png`} className="img-fluid mob" style={{ width: '100%' }} alt="" />
    </div>
  );
}
